import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GestionPlantillasService {
  private apiUrl = `${environment.ENDPOINTS.PLANTILLAS_REPORTE}`;

  constructor(private http: HttpClient) { }

  obtenerCabeceras(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/obtenerCabecerasNuevaPlantilla`);
  }

  obtenerPlantillasUsuario(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/obtenerPlantillasUsuario`);
  }

  crearNuevaPlantilla(dataPlantilla: any): Observable<any> {
    const body = JSON.stringify(dataPlantilla);
    const headers = {'Content-Type': 'application/json'};
    return this.http.post(`${this.apiUrl}/crearPlantilla`, body, { headers });
  }

  editarPlantilla(dataPlantilla: any): Observable<any> {
    const body = JSON.stringify(dataPlantilla);
    const headers = {'Content-Type': 'application/json'};
    return this.http.post(`${this.apiUrl}/editarPlantilla`, body, { headers });
  }
}
